import React from 'react';
import { Input } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

function Password({ placeholder, ...props }) {
    const { t } = useWeb5Context();

    return (
        <Input
            labelMode="horizontal"
            placeholder={placeholder || t('cfm_placeholder_type_value')}
            type="password"
            {...props}
        />
    );
}

export default React.memo(Password);
